import React from 'react'
import config from '../../../config.json'
import printConfig from '../../../print-config.json'
import Translation from '../../Translation/cont/Translation';
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple';
import ChooseWeekButtons from '../../general/ChooseWeekButtons';

const ChooseWeek = ({
    features,
    activeWeek, 
    weeks, 
    cinemaId,
    printType, 
    printID, 
    landscape,
    closePagePath,
    printToolSetWeek
}) => {
    if(!features) {
        return ''
    }

    const landscapeBoolean = landscape === "true"
    const currentPrintFormat = _.findWhere(printConfig.formats, { path: printID, landscape: landscapeBoolean })

    return (
        <WrapperPageSimple
            pageTitleTransId={printConfig.routes[printType].transIdname} 
            closePagePath={closePagePath}
        >
            <div className="program-page program-page-sorting-movies flyer print-page site-content">
                <div>
                    <h3 className="gap-20 title-list text-regular"><Translation id="print_flyer_select_week">Spielwoche auswählen</Translation></h3>

                    <ChooseWeekButtons
                        activeWeek={parseInt(activeWeek)}
                        weeks={weeks} 
                        path={`${config.routes.webtoprint.path}/${cinemaId}/${printType}/${currentPrintFormat.path}/${currentPrintFormat.landscape}`}
                        pathAfterWeek='edit'
                        updateWeek={printToolSetWeek}
                        activeWeekIsLink={true}
                    />
                </div>
            </div>
        </WrapperPageSimple>
    )
}

export default ChooseWeek